export function initGalleryLightbox($) {
  const $images = $('.wb-gallery__image');
  if (!$images.length) {
    return;
  }

  const imageItems = $images
    .map(function () {
      return {
        src: $(this).attr('src') || '',
        alt: $(this).attr('alt') || ''
      };
    })
    .get();

  if (!imageItems.length) {
    return;
  }

  let currentIndex = 0;
  let touchStartX = null;
  let touchStartY = null;
  const swipeThresholdPx = 48;
  let scrollTopBeforeOpen = 0;

  const overlayHtml = [
    '<div class="wb-lightbox" aria-hidden="true">',
    '  <div class="wb-lightbox__backdrop" data-lightbox-close></div>',
    '  <div class="wb-lightbox__content" role="dialog" aria-modal="true" aria-label="Immagine ingrandita">',
    '    <button class="wb-lightbox__nav wb-lightbox__nav--prev" type="button" aria-label="Immagine precedente">‹</button>',
    '    <button class="wb-lightbox__nav wb-lightbox__nav--next" type="button" aria-label="Immagine successiva">›</button>',
    '    <button class="wb-lightbox__close" type="button" aria-label="Chiudi">×</button>',
    '    <img class="wb-lightbox__image" src="" alt="">',
    '  </div>',
    '</div>'
  ].join('');

  const $lightbox = $(overlayHtml).appendTo(document.body);
  const $lightboxImage = $lightbox.find('.wb-lightbox__image');

  function lockPageScroll() {
    scrollTopBeforeOpen = window.pageYOffset || document.documentElement.scrollTop || 0;
    $('html, body').addClass('wb-lightbox-open');
    $('body').css({
      position: 'fixed',
      top: '-' + scrollTopBeforeOpen + 'px',
      left: '0',
      right: '0',
      width: '100%'
    });
  }

  function unlockPageScroll() {
    $('html, body').removeClass('wb-lightbox-open');
    $('body').css({
      position: '',
      top: '',
      left: '',
      right: '',
      width: ''
    });
    window.scrollTo(0, scrollTopBeforeOpen);
  }

  function normalizeIndex(index) {
    const length = imageItems.length;
    return ((index % length) + length) % length;
  }

  function renderImage(index) {
    currentIndex = normalizeIndex(index);
    const currentItem = imageItems[currentIndex] || { src: '', alt: '' };
    const total = imageItems.length;
    const fallbackAlt = 'Immagine ' + (currentIndex + 1) + ' di ' + total;

    $lightboxImage.attr('src', currentItem.src).attr('alt', currentItem.alt || fallbackAlt);
  }

  function closeLightbox() {
    $lightbox.removeClass('is-open').attr('aria-hidden', 'true');
    unlockPageScroll();
  }

  function openLightbox(index) {
    renderImage(index);
    $lightbox.addClass('is-open').attr('aria-hidden', 'false');
    lockPageScroll();
  }

  function showPreviousImage() {
    renderImage(currentIndex - 1);
  }

  function showNextImage() {
    renderImage(currentIndex + 1);
  }

  function handleSwipe(startX, startY, endX, endY) {
    if (startX === null || startY === null || endX === null || endY === null) {
      return;
    }

    const deltaX = endX - startX;
    const deltaY = endY - startY;

    if (Math.abs(deltaX) < swipeThresholdPx || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (deltaX < 0) {
      showNextImage();
      return;
    }

    showPreviousImage();
  }

  $images.on('click', function () {
    const clickedIndex = $images.index(this);
    openLightbox(clickedIndex);
  });

  $images.on('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const clickedIndex = $images.index(this);
      openLightbox(clickedIndex);
    }
  });

  $lightbox.on('click', '[data-lightbox-close], .wb-lightbox__close', closeLightbox);
  $lightbox.on('click', '.wb-lightbox__nav--prev', showPreviousImage);
  $lightbox.on('click', '.wb-lightbox__nav--next', showNextImage);
  $lightbox.on('wheel touchmove', function (event) {
    if ($lightbox.hasClass('is-open')) {
      event.preventDefault();
    }
  });

  $lightbox.on('touchstart', '.wb-lightbox__content', function (event) {
    if (!$lightbox.hasClass('is-open')) {
      return;
    }

    const touch = event.originalEvent.touches && event.originalEvent.touches[0];
    if (!touch) {
      return;
    }

    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
  });

  $lightbox.on('touchend', '.wb-lightbox__content', function (event) {
    if (!$lightbox.hasClass('is-open')) {
      return;
    }

    const touch = event.originalEvent.changedTouches && event.originalEvent.changedTouches[0];
    if (!touch) {
      touchStartX = null;
      touchStartY = null;
      return;
    }

    handleSwipe(touchStartX, touchStartY, touch.clientX, touch.clientY);
    touchStartX = null;
    touchStartY = null;
  });

  $(document).on('keydown', function (event) {
    if (!$lightbox.hasClass('is-open')) {
      return;
    }

    if (event.key === 'Escape') {
      closeLightbox();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showPreviousImage();
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showNextImage();
    }
  });
}
